/**
 * Events routed through scorecard near-real-time processing.
 *
 * Keep this list sorted alphabetically.
 */
export type ScorecardNrtEventNames =
    | 'AppHealth'
    | 'LargestSurfaceRender'
    | 'LoadCalendarModuleE2E'
    | 'MailComposeSend'
    | 'PostBootQuality'
    | 'SearchEndToEnd'
    | 'SelectMailItem'
    | 'showReadingPanePerf'
    | 'tti';

export const scorecardNrtEvents: Readonly<Record<ScorecardNrtEventNames, 1>> = Object.freeze({
    AppHealth: 1,
    LargestSurfaceRender: 1,
    LoadCalendarModuleE2E: 1,
    MailComposeSend: 1,
    PostBootQuality: 1,
    SearchEndToEnd: 1,
    SelectMailItem: 1,
    showReadingPanePerf: 1,
    tti: 1,
});

export function isScorecardNrtEvent(
    eventName: string | undefined
): eventName is ScorecardNrtEventNames {
    return (
        eventName !== undefined &&
        Object.prototype.hasOwnProperty.call(scorecardNrtEvents, eventName)
    );
}
